/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Connections_CancelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_cancel = /** @type {((inputs?: Connections_CancelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_CancelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Annuleren")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler")
	return /** @type {LocalizedString} */ ("Cancel")
});